<template>
	<div class="grid w-full gap-1 text-sm">
		<div
			v-for="{ text, icon } in usps"
			:key="text"
			class="flex gap-2 items-center py-3 px-4 bg-gray-100 rounded-lg"
		>
			<component :is="icon" class="h-6 w-6 min-w-6 text-primary" />
			<span>{{ text }}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import {
	TruckIcon,
	HomeIcon,
	ExclamationCircleIcon
} from "@heroicons/vue/24/outline";
import { computed } from "vue";
import type { StockStatusItem } from "~/types/storyblok/storyblok";

interface Props {
	stockStatus: StockStatusItem;
}

const { stockStatus } = defineProps<Props>();

const iconMap = {
	truck: TruckIcon,
	home: HomeIcon,
	"exclamation-mark": ExclamationCircleIcon
} as const;

const usps = computed(() => {
	if (!stockStatus?.usps?.length) return [];

	return stockStatus.usps
		.map((usp) => ({
			text: usp.text,
			icon: iconMap[usp.icon as keyof typeof iconMap]
		}))
		.filter((item) => item.icon);
});
</script>
